import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Home } from 'lucide-react';

export function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-180px)] -m-4 lg:-m-6">
      <Card className="w-full max-w-2xl mx-auto">
        <CardContent className="pt-12 pb-12 px-6 sm:px-8">
          <div className="flex flex-col items-center text-center space-y-6">
            {/* 404 Number */}
            <div className="relative w-full flex items-center justify-center">
              <h1 className="text-7xl sm:text-8xl lg:text-9xl font-bold text-primary/20 select-none">
                404
              </h1>
            </div>

            {/* Error Message */}
            <div className="space-y-2">
              <h2 className="text-2xl sm:text-3xl font-semibold text-foreground">
                Page Not Found
              </h2>
              <p className="text-base sm:text-lg text-muted-foreground max-w-md px-4">
                Oops! The page you're looking for doesn't exist or has been
                moved. Let's get you back on track.
              </p>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 pt-2 w-full px-4">
              <Button
                onClick={() => navigate('/dashboard')}
                size="lg"
                className="w-full sm:w-auto sm:flex-1"
              >
                <Home className="h-4 w-4 mr-2" />
                Go to Dashboard
              </Button>
            </div>

            {/* Quick Links */}
            <div className="pt-6 border-t w-full mt-2">
              <p className="text-sm text-muted-foreground mb-4">Quick Links:</p>
              <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3">
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => navigate('/products-management')}
                  className="text-sm"
                >
                  Products
                </Button>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => navigate('/user-management')}
                  className="text-sm"
                >
                  Users
                </Button>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => navigate('/showroom')}
                  className="text-sm"
                >
                  Showroom
                </Button>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => navigate('/chat')}
                  className="text-sm"
                >
                  Chat
                </Button>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
